import { muscleKey, startOfLocalDay, type CatalogMuscleSlug } from '@heraion/shared';

type Tr = (key: string, opts?: Record<string, unknown>) => string;

/** One line of the empty «today» card's rest fact: the muscles that come back
 *  on one day. `text` shows the short weekday and DD/MM; `label` is what a
 *  screen reader says, with the long names («ven», «Fr.», «пт» read badly). */
export type RestingGroup = { text: string; label: string };

/** The resting muscles grouped by the local day they come back, soonest
 *  first. Empty when nothing rests. */
export const restingGroups = (
  resting: ReadonlyArray<{ muscle: CatalogMuscleSlug; returnMs: number }> | undefined,
  t: Tr,
  locale: string,
): RestingGroup[] => {
  if (!resting || resting.length === 0) return [];
  const short = new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
  });
  const long = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' });
  const byDay = new Map<number, CatalogMuscleSlug[]>();
  for (const r of [...resting].sort((a, b) => a.returnMs - b.returnMs)) {
    const day = startOfLocalDay(r.returnMs);
    byDay.set(day, [...(byDay.get(day) ?? []), r.muscle]);
  }
  return [...byDay].map(([ms, muscles]) => {
    const names = muscles.map((m) => t(muscleKey(m))).join(', ');
    const say = (f: Intl.DateTimeFormat) =>
      t('mobile.logger.draftToday.restingUntil', { muscles: names, day: f.format(ms) });
    return { text: say(short), label: say(long) };
  });
};
